export default __webpack_public_path__ + "static/media/medical_nurses.ad3f2280.svg";